import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from './permission.service';

/**
 * EB-3709: Brand Manager route guard. Redirects to '/' when the user has
 * no `amie.brandManager.*` module. The titlebar also hides the nav entry —
 * this guard catches deep-links / typed URLs.
 */
export const brandManagerGuard: CanActivateFn = () => {
  // EB-3709 I2 — SAFE: authGuard precedes us in canActivate and gates on
  // accessState='authorized', which is set only AFTER
  // PermissionService.loadModules() resolves in AuthService.evaluateAccess().
  // Do not reorder guards without re-checking this dependency.
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  if (permissionService.canRead('brandManager')) {
    return true;
  }
  return router.parseUrl('/');
};
